
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/syncs/retries",
      function () {
        return require("private-next-pages/syncs/retries.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/syncs/retries"])
      });
    }
  